import { useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BsArrowLeftShort } from "react-icons/bs";
import Input from "../../components/elements/form/Input";
import H2 from "../../components/elements/titles/H2";
import Paragraph from "../../components/elements/p/Paragraph";
import ButtonAction from "../../components/elements/buttons/ButtonAction";
import currentAdminContext from "../../dataManager/context/currentAdminContext";
import Alert from "../../components/elements/alerts/Alerts";
import {
  generateRecaptchaVerifier,
  sendOptCodeToTheUser,
  siginUserWithOtpCode,
} from "../../api/users/usersApi";
import InputPhone from "../../components/elements/form/InputPhone";

const BodyLoginUser = () => {
  const navigate = useNavigate();

  //context variables
  const { currentAdmin, login } = useContext(currentAdminContext);

  //state variable
  const [phone, setPhone] = useState(null);
  const [otpCode, setOtpCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [confirmationResult, setConfirmationResult] = useState(null);

  //some handlers
  const handleAskForOtpCode = async (e) => {
    e.preventDefault();

    if (phone.lenght < 4) {
      setError("Entrez un numéro de téléphone valide");
      return;
    }

    //start loading
    setLoading(true);

    const recaptchaVerifier = generateRecaptchaVerifier("recaptcha-container");
    const { data, error } = await sendOptCodeToTheUser(
      phone,
      recaptchaVerifier
    );

    if (data) {
      setConfirmationResult(data);
      return setLoading(false);
    }

    setError("Une erreur est survenu, verifiez votre numéro de téléphone");
    setLoading(false);
  };

  const handleSignInWithOtpCode = async (e) => {
    e.preventDefault();

    if (otpCode.length !== 6)
      return setError("Le code envoyé à 6 chiffres veuillez recommencer");

    //start loading
    setLoading(true);

    const { data, error } = await siginUserWithOtpCode(
      otpCode,
      confirmationResult,
      phone
    );

    if (data) {
      console.log(data);
      return setLoading(false);
    }

    setError(
      `Vérifiez le code envoyé au ${phone} si c'est bien ce que vous avez entrée alors actualisez la page sinon modifiez le code`
    );
    setLoading(false);
  };

  useEffect(() => {
    if (currentAdmin && currentAdmin?.getRole === 0) {
      //stop loading
      setLoading(false);

      //redirect to user profile
      navigate(`/user/${currentAdmin.getId}`);

      console.log("hello guy");
    }
  }, [currentAdmin]);

  const choiseTheInputBox = !confirmationResult ? (
    <InputPhone
      labelName="Numéro de télephone"
      placeholder="numéro de téléphone"
      value={phone}
      onChange={setPhone}
    />
  ) : (
    <>
      <Input
        labelName="Code de vérification"
        type="number"
        value={otpCode}
        onChange={(e) => {
          setError("");
          setOtpCode(e.target.value);
        }}
        classe="mt-6"
        placeholder="XXXXXX"
      />

      <Paragraph size="small">
        Vous n'avez pas reçu de code ?{" "}
        <span
          onClick={() => window.location.reload()}
          className="cursor-pointer text-[#403eac]"
        >
          cliquez-ici
        </span>{" "}
        pour envoyer à nouveau{" "}
      </Paragraph>
    </>
  );

  return (
    <form
      onSubmit={(e) =>
        !confirmationResult
          ? handleAskForOtpCode(e)
          : handleSignInWithOtpCode(e)
      }
      className=" mx-auto mt-[150px] w-full max-w-[400px] px-4 md:mt-[200px] "
    >
      <Link
        to="/"
        className="animate flex items-center space-x-1 hover:text-primary"
      >
        <BsArrowLeftShort />
        <Paragraph size="small">retour a l'accueil</Paragraph>
      </Link>
      <span className="font-nunito text-sm text-[#fc3838]">
        {error && error}
      </span>
      <div className="my-2">
        <H2 classe="my-2">Connexion</H2>
        <Paragraph size="small">
          Connectez-vous à l'aide de votre numéro de téléphone pour mieux gérer
          vos commandes.
        </Paragraph>
      </div>
      <div className=" mt-2 rounded border border-secondary px-3 py-5 md:p-5">
        <div>
          <Alert type={!confirmationResult ? "info" : "success"}>
            {!confirmationResult ? (
              <Paragraph size="small">
                Nous allons vous envoyer un code de vérification par sms à votre
                numéro
              </Paragraph>
            ) : (
              <Paragraph size="small">
                Le code de vérification a été envoyé par SMS à votre numéro
                renseignez-le
              </Paragraph>
            )}
          </Alert>
        </div>

        <div className="my-6">{choiseTheInputBox}</div>
        <ButtonAction size="small" loading={loading}>
          {!confirmationResult ? "Envoyer le code" : "Connexion"}
        </ButtonAction>
      </div>
      <div id="recaptcha-container"></div>
    </form>
  );
};

export default BodyLoginUser;
